import type { RouteRecordRaw } from 'vue-router'
import routerNames from './routerNames'
import routerTitle from './RouterTitle'

const StepRouter: RouteRecordRaw = {
  path: '/projects',
  component: () => import('@/layouts/FullLayout.vue'),
  redirect: { name: routerNames.CREATE_PROJECT },
  meta: {
    requiresAuth: true
  },
  children: [
    {
      name: routerNames.CREATE_PROJECT,
      path: 'create',
      component: () => import('@/views/Step/BasicInformationView.vue'),
      meta: {
        title: routerTitle.CREATE_PROJECT
      }
    },
    {
      name: routerNames.STEP_INFORMATION,
      path: ':projectId/publish',
      component: () => import('@/views/Step/BasicInformationView.vue'),
      meta: {
        title: routerTitle.STEP_INFORMATION
      }
    },
    {
      name: routerNames.STEP_UPLOAD,
      path: ':projectId/publish',
      component: () => import('@/views/Step/UploadView.vue'),
      meta: {
        title: routerTitle.STEP_UPLOAD
      }
    },
    {
      name: routerNames.STEP_PERSPECTIVE_DELIVERY,
      path: ':projectId/publish',
      component: () => import('@/views/Step/PerspectiveDeliveryView.vue'),
      meta: {
        title: routerTitle.STEP_PERSPECTIVE_DELIVERY
      }
    },
    {
      name: routerNames.STEP_VIEWER,
      path: ':projectId/publish',
      component: () => import('@/views/Step/ViewerView.vue'),
      meta: {
        title: routerTitle.STEP_VIEWER
      }
    },
    {
      name: routerNames.STEP_CONFIRMATION,
      path: ':projectId/publish',
      component: () => import('@/views/Step/ConfirmationView.vue'),
      meta: {
        title: routerTitle.STEP_CONFIRMATION
      }
    },
    {
      name: routerNames.STEP_COMPLETED,
      path: ':projectId/publish',
      component: () => import('@/views/Step/CompletedView.vue'),
      meta: {
        title: routerTitle.STEP_COMPLETED
      }
    }
  ]
}

export default StepRouter
